/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import {
  IAny,
  IEmaasEnergyUsageComponentData
} from '../../../../../DashboardKPIWidgets/IEnergyManagementProps';
import DetailSummaryComponent from '../../../../../shared/DetailSummaryComponent/DetailSummaryComponent';
import PerformanceGraph from '../../../../../shared/PerformanceGraph/PerformanceGraph';
import {
  MAGIC_VALUE,
  PreferredUnit
} from '../../../../../shared/Utils/Constants';
import {
  convertChartPremiumToBasic,
  getNullCheckedAggregationSummaryData
} from '../../../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import {
  formatCommonEnergyData,
  getToUnitForChart
} from '../../../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import {
  getPerformanceGraphData,
  getPerformanceGraphDataNew
} from '../../../../../shared/Utils/Utils';
import { ApiContext } from '../../../../../../context/ApiContext';
import descriptors from '../../../../../../locales/en-US/descriptors';
import { EnergyUsageField } from '../../../../../shared/Enums';
import TrendChart from '../../../../../shared/TrendChart/TrendChart';
import { useTranslation } from '@scuf/localization';
import { UnitUtility } from '@bmsp/bmsp.web.component.common';
import { getEnergyTotalUsagesGraphValues } from '../../../../../shared/Utils/unitHandling/EmaasSiteKpiDataScaling';
import { getMaxConvertedValueFromArray } from '../../../../../../main';

export interface IEnergyUsagesAllUtilityDetailsComponentProps {
  data: IEmaasEnergyUsageComponentData;
  tabName?: string;
  forSummary?: boolean;
  forGraph?: boolean;
}
const PortfolioEnergyTopComponentSeparate = (
  props: IEnergyUsagesAllUtilityDetailsComponentProps
) => {
  const d = descriptors.energyManagement;
  const [t, lng] = useTranslation();
  const { data, tabName } = props;
  const {
    performanceAggregation,
    aggregationsStartDate,
    performanceAggregationApplied,
    energyMeasurementUnit,
    monthWiseAggregations,
    summary,
    sourceType
  } = data;

  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;
  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }
  fromUnit =
    sourceType.toString().toLowerCase() === 'water'
      ? PreferredUnit.Water
      : userPreferedUnit === 'megajoule'
      ? userPreferedUnit
      : tabName === 'gas'
      ? apiContext.toggleEnableKwhGas
        ? PreferredUnit.Electricity
        : PreferredUnit.Gas
      : // : tabName === 'allutilities'
        // ? PreferredUnit.Electricity
        PreferredUnit.Electricity;

  const {
    conversionType,
    aggregationSummaryData,
    maxValueUnitConversion,
    aggregationsEndDate,
    deviationScaledData
  } = formatCommonEnergyData(
    data,
    fromUnit,
    apiContext.showChangeWhenData,
    true
  );

  // const ConvertToUnit = getToUnitForChart(
  //   conversionType.toLowerCase() === 'water' ? [] : performanceAggregation,
  //   conversionType,
  //   fromUnit //energyMeasurementUnit
  // );
  // const comparisonData = getPerformanceGraphData(
  //   conversionType.toLowerCase() === 'water' ? [] : performanceAggregation,
  //   energyMeasurementUnit,
  //   ConvertToUnit,
  //   performanceAggregationApplied,
  //   conversionType
  // );

  let maxGraphValueUnitConversion: any;

  let graphValuesArray: any;

  let comparisonData: any;

  if (props.forGraph && data.performanceAggregation != null) {
    console.log(props.forSummary);
    console.log(data.performanceAggregation);
    graphValuesArray = getEnergyTotalUsagesGraphValues(performanceAggregation);
    maxGraphValueUnitConversion = getMaxConvertedValueFromArray(
      conversionType,
      fromUnit, //energyMeasurementUnit,
      graphValuesArray,
      energyMeasurementUnit
    );
    comparisonData =
      performanceAggregationApplied === 'Hourly'
        ? getPerformanceGraphData(
            conversionType.toLowerCase() === 'water'
              ? []
              : performanceAggregation,
            energyMeasurementUnit,
            //ConvertToUnit,
            maxGraphValueUnitConversion.Unit,
            performanceAggregationApplied,
            conversionType
          )
        : getPerformanceGraphDataNew(
            conversionType.toLowerCase() === 'water'
              ? []
              : performanceAggregation,
            energyMeasurementUnit,
            maxGraphValueUnitConversion.Unit,
            performanceAggregationApplied,
            conversionType,
            data.aggregationsStartDate,
            data.aggregationsEndDate
          );
  }

  let isNullCheckedData: IAny = {};
  if (props.forSummary) {
    isNullCheckedData = getNullCheckedAggregationSummaryData(
      aggregationSummaryData,
      summary,
      apiContext.showChangeWhenData
    );
  }

  // const isNullCheckedData = getNullCheckedAggregationSummaryData(
  //   aggregationSummaryData,
  //   summary,
  //   apiContext.showChangeWhenData
  // );

  let legendItems: IAny;
  let basicGraphData: IAny;
  if (props.forGraph && data.monthWiseAggregations != null) {
    legendItems = [
      {
        text: t(d.PREVIOUSPERIOD),
        color: '#606061',
        className: 'emaas-legend-item-bar-baseline',
        type: 'Bar'
      },
      {
        text: t(d.ACTUAL),
        color: '#1272B2',
        className: 'emaas-legend-item-bar-actual',
        type: 'Bar'
      }
    ];
  }
  if (props.forGraph && data.monthWiseAggregations != null) {
    basicGraphData = convertChartPremiumToBasic(
      conversionType.toLowerCase() === 'water' ? monthWiseAggregations : [],
      fromUnit, //energyMeasurementUnit
      conversionType,
      energyMeasurementUnit,
      lng
    );
  }
  return (
    <div className="allUtility-performance-detail-container">
      <div>
        {props.forSummary && (
          <DetailSummaryComponent
            aggregationData={isNullCheckedData}
            measurementUnit={maxValueUnitConversion.Unit}
            detailType="detailSummaryWithoutCurrency"
            category="EnergyUsage"
            deviationScaledData={deviationScaledData}
            fromCarbonScopeOne={true}
            sourceType={sourceType}
            waterAvgUnit={energyMeasurementUnit}
          />
        )}
        {props.forGraph &&
          (sourceType == 'Water' ? (
            <TrendChart
              measurementUnit={basicGraphData.chartUnit}
              legendItems={legendItems}
              chartData={basicGraphData}
              category={EnergyUsageField.ENERGY_USAGE}
            />
          ) : (
            <PerformanceGraph
              chartSeries={comparisonData}
              startTime={aggregationsStartDate}
              endTime={aggregationsEndDate}
              aggregationType={performanceAggregationApplied}
              height={''}
              spacing={[MAGIC_VALUE.THIRTY, 0, 0, 0]}
              conversionType={conversionType}
            />
          ))}
      </div>
    </div>
  );
};

export default PortfolioEnergyTopComponentSeparate;
